import { environment } from '../../environments/environment';

/**
 * Configuration that can change without rebuilding the frontend.
 *
 * `apiUrl` defaults to the URL of the Angular environment the image was built
 * with. The view container may override it at start with the env variable
 * `API_URL`; nginx then serves it as `/config.json`, which `main.ts` loads
 * before the app starts (see view/docker-entrypoint.d/40-runtime-config.sh).
 */
export const runtimeConfig = {
  /** Base URL of the API, always ending with `/`. */
  apiUrl: environment.apiUrl,
};

/**
 * Loads `/config.json` into `runtimeConfig`. Keeps the defaults when the file
 * is missing or invalid (e.g. `ng serve`), so the app always starts.
 */
export async function loadRuntimeConfig(fetchFn: typeof fetch = fetch): Promise<void> {
  try {
    const response = await fetchFn('/config.json', { cache: 'no-store' });
    if (!response.ok) return;
    const config = (await response.json()) as { apiUrl?: unknown };
    if (typeof config.apiUrl === 'string' && /^https?:\/\/[^/]+/.test(config.apiUrl)) {
      runtimeConfig.apiUrl = config.apiUrl.endsWith('/') ? config.apiUrl : `${config.apiUrl}/`;
    }
  } catch {
    // no runtime configuration: keep the build-time URL
  }
}
